"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.mogamboRequestV3 = exports.getEncodedStr = exports.mogamboRequestV2 = exports.appendVersionToURL = exports.getSelfServeURL = exports.sameOrigin = exports.csrfSafeMethod = exports.getCookie = void 0;
require("whatwg-fetch");
var bole_1 = __importDefault(require("@haptik/helpers/build/esm/bole"));
var store_1 = __importDefault(require("@src/store"));
function getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i += 1) {
            var cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === name + "=") {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
exports.getCookie = getCookie;
function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
}
exports.csrfSafeMethod = csrfSafeMethod;
function sameOrigin(url) {
    // test that a given url is a same-origin URL
    // url could be relative or scheme relative or absolute
    var host = document.location.host; // host + port
    var protocol = document.location.protocol;
    var srOrigin = "//" + host;
    var origin = protocol + srOrigin;
    // Allow absolute or scheme relative URLs to same origin
    return (url === origin ||
        url.slice(0, origin.length + 1) === origin + "/" ||
        url === srOrigin ||
        url.slice(0, srOrigin.length + 1) === srOrigin + "/" ||
        // or any other URL that isn't scheme relative or absolute i.e relative.
        !/^(\/\/|http:|https:).*/.test(url));
}
exports.sameOrigin = sameOrigin;
function authenticate(json) {
    // Check if there was no authentication problem
    // Todo: Redirect to current page instead of Mogambo Home Page
    if (json.not_authenticated) {
        window.location.href = '/login/?next=/mogambo/';
    }
    return true;
}
function getSelfServeURL(url) {
    var selfServeParam = store_1["default"].getSelfServeLayout() ? '&version=2' : '';
    return url + selfServeParam;
}
exports.getSelfServeURL = getSelfServeURL;
function appendVersionToURL(url, version) {
    return url + "&version=" + version;
}
exports.appendVersionToURL = appendVersionToURL;
exports.mogamboRequestV2 = function (url, method, body, ignoreSuccessFlag, additionalHeaders) {
    if (additionalHeaders === void 0) { additionalHeaders = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var wwIva, botName, headers, request, response, json, defaultError, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    wwIva = JSON.parse(localStorage.getItem('ww_iva'));
                    botName = (wwIva === null || wwIva === void 0 ? void 0 : wwIva.isSmartSkill) ? wwIva === null || wwIva === void 0 ? void 0 : wwIva.domain_name : wwIva === null || wwIva === void 0 ? void 0 : wwIva.title;
                    headers = __assign({ 'Content-Type': 'application/json', 'x-haptik-bot-name': botName }, additionalHeaders);
                    if (!csrfSafeMethod(method) && sameOrigin(url)) {
                        headers['X-CSRFToken'] = getCookie('csrftoken');
                    }
                    request = new Request(url, {
                        method: method,
                        headers: new Headers(headers),
                        credentials: 'same-origin',
                        mode: 'cors',
                        cache: 'default',
                        body: JSON.stringify(body),
                    });
                    return [4 /*yield*/, fetch(request)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    json = _a.sent();
                    defaultError = 'An error occured';
                    authenticate(json);
                    // If the status is 403, which means permission denied, then rejecting it will
                    // throw an error in sentry which is not needed there.
                    if (response.status === 403)
                        return [2 /*return*/, Promise.resolve(json)];
                    if (json.error)
                        return [2 /*return*/, Promise.reject(json.error)];
                    if (!ignoreSuccessFlag && json.success === false)
                        return [2 /*return*/, Promise.reject(defaultError)];
                    return [2 /*return*/, Promise.resolve(json)];
                case 3:
                    e_1 = _a.sent();
                    if (!ignoreSuccessFlag)
                        return [2 /*return*/, Promise.reject(e_1)];
                    return [2 /*return*/, Promise.resolve({
                            success: false,
                        })];
                case 4: return [2 /*return*/];
            }
        });
    });
};
exports.getEncodedStr = function (obj) {
    if (!obj)
        return '';
    var params = Object.keys(obj)
        .reduce(function (acc, key) {
        if (typeof obj[key] !== 'undefined') {
            acc = __spreadArrays(acc, [key + "=" + obj[key]]);
        }
        return acc;
    }, [])
        .join('&');
    return encodeURI(params);
};
/**
 * checks whether backend has sent an error
 * @param status status code of api call
 */
var hasError = function (status) {
    var ERROR_HEADERS = [400, 403, 405, 500];
    return ERROR_HEADERS.includes(status);
};
/**
 * Function to make API calls
 * @param url url endpoint to make request
 * @param method type of request. ex- get, post
 * @param data additional data to send
 */
function mogamboRequestV3(url, method, data, signal, additionalHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var wwIva, botName, requestUrl, headers, getFormattedData, updatedHeaders, request, response, e_2, contentType, json, fileData, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    wwIva = JSON.parse(localStorage.getItem('ww_iva'));
                    botName = (wwIva === null || wwIva === void 0 ? void 0 : wwIva.isSmartSkill) ? wwIva === null || wwIva === void 0 ? void 0 : wwIva.domain_name : wwIva === null || wwIva === void 0 ? void 0 : wwIva.title;
                    requestUrl = new URL(url);
                    headers = data instanceof FormData ? {} : { 'Content-Type': 'application/json' };
                    getFormattedData = function () {
                        return data instanceof FormData ? data : JSON.stringify(data);
                    };
                    if (method === 'GET' && data) {
                        Object.keys(data).forEach(function (key) {
                            return requestUrl.searchParams.append(key, data[key]);
                        });
                    }
                    if (!csrfSafeMethod(method) && sameOrigin(url)) {
                        headers['X-CSRFToken'] = getCookie('csrftoken');
                    }
                    headers['x-haptik-bot-name'] = botName;
                    updatedHeaders = __assign(__assign({}, headers), additionalHeaders);
                    request = new Request(requestUrl.href, {
                        method: method || 'GET',
                        headers: new Headers(updatedHeaders),
                        cache: 'default',
                        signal: signal || null,
                        body: method !== 'GET' && data ? getFormattedData() : undefined,
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(request)];
                case 2:
                    response = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    return [2 /*return*/, Promise.reject(e_2)];
                case 4:
                    _a.trys.push([4, 9, , 10]);
                    contentType = response.headers.get('content-type');
                    if (!(contentType && contentType.indexOf('application/json') !== -1)) return [3 /*break*/, 6];
                    return [4 /*yield*/, response.json()];
                case 5:
                    json = _a.sent();
                    if (!json.body) {
                        bole_1["default"].error("response body is not present - " + JSON.stringify(json) + ", " + response.status + ", " + url);
                    }
                    if (json.not_authenticated) {
                        authenticate(json);
                    }
                    // TODO: Optimise this approach
                    // Ticket: https://hello-haptik.atlassian.net/browse/BB-3261
                    if (hasError(response.status)) {
                        return [2 /*return*/, Promise.resolve({
                                success: false,
                                response: json,
                            })];
                    }
                    return [2 /*return*/, Promise.resolve({ success: true, response: json })];
                case 6:
                    if (!(contentType && contentType.indexOf('text/csv') !== -1)) return [3 /*break*/, 8];
                    return [4 /*yield*/, response.blob()];
                case 7:
                    fileData = _a.sent();
                    return [2 /*return*/, Promise.resolve({
                            success: true,
                            response: fileData,
                        })];
                case 8:
                    bole_1["default"].error("Invalid Response Format, " + response.status + ", " + url);
                    return [2 /*return*/, Promise.reject(new Error('API Request Failed'))];
                case 9:
                    e_3 = _a.sent();
                    return [2 /*return*/, Promise.reject(e_3)];
                case 10: return [2 /*return*/];
            }
        });
    });
}
exports.mogamboRequestV3 = mogamboRequestV3;
